import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Alert from '@eversports/klimt-primitives/legacy/Alert'
import Snackbar from '@eversports/klimt-primitives/legacy/Snackbar'
import Text from '@eversports/klimt-primitives/legacy/Text'

interface Props {
  isOpen: boolean
  errorMessage: string
  onClose: () => void
}

const ErrorSnackbar = ({ isOpen, errorMessage, onClose }: Props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'bottom', horizontal: isMobile ? 'center' : 'right' }}
      sx={{ bottom: '80px' }}
      onClose={onClose}
    >
      <Alert severity="error" variant="filled">
        <Text sx={{ color: 'white' }}>{errorMessage}</Text>
      </Alert>
    </Snackbar>
  )
}

export default ErrorSnackbar
